import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import i18n from "../i18n";
import moment from "moment";

function isValidDate(dateData) {
  var pattern = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
  var m = dateData.match(pattern);
  if (!m) {
    return false;
  } else {
    return true;
  }
}

export async function loadVeeValidate(locale) {
  if (locale == "vi") locale = "vi";
  const { messages } = await import(`vee-validate/dist/locale/${locale}.json`);
  Object.keys(rules).forEach(rule => {
    extend(rule, {
      ...rules[rule], // copies rule configuration
      message: messages[rule] // assign message
    });
  });
}

export async function loadVeeValidateExtend() {
  extend("between_time_start_date", {
    validate(value, end_date) {
      if (end_date.date && value) {
        let startDate1 = value.split("/");
        let endDate1 = end_date.date.split("/");
        let startDate = new Date(
          startDate1[2],
          startDate1[1] - 1,
          startDate1[0]
        ).getTime();
        let endDate = new Date(
          endDate1[2],
          endDate1[1] - 1,
          endDate1[0]
        ).getTime();
        let sumDate = endDate - startDate;
        let check = false;
        if (sumDate >= 0) {
          check = true;
        }
        return check;
      }
      return true;
    },
    params: ["date"],
    message: i18n.t("sabbatical.start_date_less")
  });

  extend("between_time_end_date", {
    validate(value, start_date) {
      if (start_date.date && value) {
        let startDate1 = start_date.date.split("/");
        let endDate1 = value.split("/");
        let startDate = new Date(
          startDate1[2],
          startDate1[1] - 1,
          startDate1[0]
        ).getTime();
        let endDate = new Date(
          endDate1[2],
          endDate1[1] - 1,
          endDate1[0]
        ).getTime();
        let sumDate = endDate - startDate;
        let check = false;
        if (sumDate >= 0) {
          check = true;
        }
        return check;
      }
      return true;
    },
    params: ["date"],
    message: i18n.t("sabbatical.end_date_fewer")
  });

  extend("between_time_start_time", {
    validate(value, { morning_shift_start }) {
      let check = false;
      if (value) {
        if (value >= morning_shift_start) {
          check = true;
        }
        return check;
      }
      return true;
    },
    params: ["morning_shift_start"],
    message: i18n.t("sabbatical.start_time_between")
  });

  extend("between_time_end_time", {
    validate(value, { afternoon_shift_end }) {
      let check = false;
      if (value) {
        if (value <= afternoon_shift_end) {
          check = true;
        }
        return check;
      }
      return true;
    },
    params: ["afternoon_shift_end"],
    message: i18n.t("sabbatical.end_time_between")
  });

  extend("less_end_time", {
    validate(value, data) {
      let check = true;
      if (data.date.start_date && data.date.end_date && data.date.end_time) {
        let start_date = data.date.start_date.split("/");
        let end_date = data.date.end_date.split("/");
        let start_time = value.split(":");
        let hours_start_time = start_time[0] * 1 + start_time[1] / 60;
        let end_time = data.date.end_time.split(":");
        let hours_end_time = end_time[0] * 1 + end_time[1] / 60;
        let startDate = new Date(
          start_date[2],
          start_date[1] - 1,
          start_date[0]
        ).getTime();
        let endDate = new Date(
          end_date[2],
          end_date[1] - 1,
          end_date[0]
        ).getTime();
        let sumDate = endDate - startDate;
        if (sumDate === 0) {
          if (hours_end_time <= hours_start_time) {
            check = false;
          }
        }
        return check;
      }
      return true;
    },
    params: ["date"],
    message: i18n.t("sabbatical.start_time_less")
  });

  extend("fewer_start_time", {
    validate(value, data) {
      if (data.date.start_date && data.date.end_date && data.date.start_time) {
        let check = true;
        let start_date = data.date.start_date.split("/");
        let end_date = data.date.end_date.split("/");
        let end_time = value.split(":");
        let hours_end_time = end_time[0] * 1 + end_time[1] / 60;
        let start_time = data.date.start_time.split(":");
        let hours_start_time = start_time[0] * 1 + start_time[1] / 60;
        let startDate = new Date(
          start_date[2],
          start_date[1] - 1,
          start_date[0]
        ).getTime();
        let endDate = new Date(
          end_date[2],
          end_date[1] - 1,
          end_date[0]
        ).getTime();
        let sumDate = endDate - startDate;
        if (sumDate === 0) {
          if (hours_end_time <= hours_start_time) {
            check = false;
          }
        }
        return check;
      }
      return true;
    },
    params: ["date"],
    message: i18n.t("sabbatical.end_time_fewer")
  });

  extend("less_number_of_days_off_rest", {
    validate(value, data) {
      let check = true;
      if (data.date.reason_type && data.date.number_of_days_off_rest) {
        if (parseInt(data.date.reason_type) === 1) {
          if (value > data.date.number_of_days_off_rest) {
            check = false;
          }
        }
        return check;
      }
      return true;
    },
    params: ["date"],
    message: i18n.t("sabbatical.less_number_of_days_off_rest")
  });

  extend("less_number_of_days_off_rest_update", {
    validate(value, data) {
      let check = true;
      if (data.date.reason_type && data.date.days_off_rest) {
        if (parseInt(data.date.reason_type) === 1) {
          if (value > data.date.days_off_rest) {
            check = false;
          }
        }
        return check;
      }
      return true;
    },
    params: ["date"],
    message: i18n.t("sabbatical.less_number_of_days_off_rest_update")
  });

  extend("before_or_equal_today", {
    validate(value) {
      let today = moment(new Date(), "DD/MM/YYYY");
      let workDate = moment(value, "DD/MM/YYYY");
      return today.isSameOrAfter(workDate);
    },
    params: ["date"],
    message: field =>
      i18n.t(field) + " " + i18n.t("error.before_or_equal_today")
  });

  extend("required_date", {
    validate(value) {
      if (!isValidDate(value)) {
        return false;
      }
      return true;
    },
    params: ["date"],
    message: field => i18n.t(field) + " " + i18n.t("error.require")
  });

  extend("start_time_is_not_fit", {
    validate(value) {
      let check = true;
      let time_17_h_30_m = "17:30";
      if (value === time_17_h_30_m) {
        check = false;
        return check;
      }
      return true;
    },
    params: ["date"],
    message: i18n.t("sabbatical.start_time_is_not_fit")
  });

  extend("end_time_is_not_fit", {
    validate(value) {
      let check = true;
      let time_08_h = "08:00";
      if (value === time_08_h) {
        check = false;
        return check;
      }
      return true;
    },
    params: ["date"],
    message: i18n.t("sabbatical.end_time_is_not_fit")
  });

  extend("end_date_is_not_same_start_date", {
    validate(value, data) {
      if(!data.date.reason_type){
        return true;
      } 

      if(data.date.start_date == data.date.end_date) {
        return true;
      }
      return false;
     
    },
    params: ["date"],
    message: i18n.t("sabbatical.end_date_is_not_same_start_date")
  });
  extend("end_time_is_too_long_for_physiological_leave_from_start_time", {
    validate(value, data) {
      if(!data.date.reason_type){
        return true;
      } 
      const endTime = data.date.end_time.split(":");
      const startTime = data.date.start_time.split(":");

      const howLongMinutes = 60*(parseInt(endTime[0]) - parseInt(startTime[0])) + parseInt(endTime[1]) - parseInt(startTime[1])
      if(howLongMinutes > 90) {
        return false
      }
      return true;
     
    },
    params: ["date"],
    message: i18n.t("sabbatical.end_time_is_too_long_from_start_time_for_physiological_leave")
  });
  extend("month_is_curent_month", {
    validate(value, data) {
      if(!data.date.reason_type){
        return true;
      } 
      const startDate = data.date?.start_date?.split("/");
      const endDate = data.date?.end_date?.split("/");
      const now = new Date();
      const currentMonth = now.getMonth() + 1;
      if(startDate && currentMonth == startDate[1]) {
        return true;
      }
      if(endDate && currentMonth == endDate[1]) {
        return true;
      }
      return false;
     
    },
    params: ["date"],
    message: i18n.t("sabbatical.month_is_must_current_month")
  });
  extend("less_than_minutes_can_request", {
    validate(value, data) {
      const timeRequest = data.date.time_request;
      const maxTimeRequest = data.date.max_time_request;

      if(timeRequest > maxTimeRequest) {
        return false;
      }
      return true;
     
    },
    params: ["date"],
    message: i18n.t("sabbatical.time_request_for_physiology_over")
  });
  extend("less_than_times_can_request", {
    validate(value, data) {
      const max_times_can_request = data.date.max_times_can_request;

      if(max_times_can_request > 0) {
        return true;
      }
      return false;
     
    },
    params: ["date"],
    message: i18n.t("sabbatical.times_of_request_for_physiology_over")
  });
  
}
